import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";
import { Stack } from "@mui-wrapper";

/** Default dimensions for mobile list item cards */
const LIST_ITEM_CARD_MOBILE_DEFAULTS = {
  imageWidth: 132,
  imageHeight: 96,
  gap: 1,
  padding: 1,
  textHeightSmall: 16,
  textHeightMedium: 20,
  textHeightLarge: 18,
  textWidthSmall: "60%",
  textWidthMedium: "80%",
  textWidthLarge: "40%"
};

/**
 * Skeleton component to show a loading state for list item cards on mobile.
 */
export function SkeletonProjectListItemCard() {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      flexDirection: "row",
      gap: LIST_ITEM_CARD_MOBILE_DEFAULTS.gap,
      p: LIST_ITEM_CARD_MOBILE_DEFAULTS.padding
    };
    t1 = <Skeleton variant="rounded" width={LIST_ITEM_CARD_MOBILE_DEFAULTS.imageWidth} height={LIST_ITEM_CARD_MOBILE_DEFAULTS.imageHeight} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      flex: 1,
      minWidth: 0,
      justifyContent: "space-between"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Stack sx={t0}>{t1}<Stack sx={t2}><Stack sx={{
          gap: 0.5
        }}><Skeleton width={LIST_ITEM_CARD_MOBILE_DEFAULTS.textWidthSmall} height={LIST_ITEM_CARD_MOBILE_DEFAULTS.textHeightSmall} /><Skeleton width={LIST_ITEM_CARD_MOBILE_DEFAULTS.textWidthMedium} height={LIST_ITEM_CARD_MOBILE_DEFAULTS.textHeightMedium} /></Stack><Skeleton width={LIST_ITEM_CARD_MOBILE_DEFAULTS.textWidthLarge} height={LIST_ITEM_CARD_MOBILE_DEFAULTS.textHeightLarge} /></Stack></Stack>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}